import { gql } from "@apollo/client";

export const EVENTS = gql`
  query Events(
    $where: EventWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
    $gt: EventWhereInput
    $lt: EventWhereInput
  ) {
    events(
      where: $where
      take: $take
      skip: $skip
      orderBy: $orderBy
      gt: $gt
      lt: $lt
    ) {
      data {
        id
        meta
        startDate
        endDate
        allDay
        type
        reminder {
          id
          scheduledDate
          content
          user {
            id
            firstname
            lastname
          }
        }
      }
      count
    }
  }
`;

export const EVENT = gql`
  query Event($where: EventWhereInput) {
    event(where: $where) {
      id
      meta
      startDate
      endDate
      allDay
      type
      reminder {
        id
        scheduledDate
        content
        user {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

const events = { EVENTS, EVENT };

export default events;
